function getCookie(key) {
    const b = document.cookie.match(`(^|[^;]+)\\s*${ key }\\s*=\\s*([^;]+)`);

    return b ? b.pop() : null;
}

// max age is set to 1 year by default
function setCookie(key, value, maxAgeInSeconds = 31536000) {
    document.cookie = `${ key }=${ value };max-age=${ maxAgeInSeconds };path=/`;
}

export { getCookie, setCookie };
